import React from "react";
import ic_job_creation_success from "../img/ic_job_creation_success.png";
import "../css/Job_creation_success_popup.css";

function Job_creation_success_popup(props) {

    const {closePopupAfterSuccessfulJobCreation} = props;

    return (
        <div className="Job_creation_success_popup_root_container">
            <img src={ic_job_creation_success} />
            <label>Job Created Successfully</label>
            <button className="common_black_button mt-4" onClick={()=>closePopupAfterSuccessfulJobCreation()}>Ok</button>
        </div>
    )
}

export default Job_creation_success_popup;